import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectAdminLevel1 = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.adminLevel1 && validation.errors.adminLevel1
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.adminLevel1 && validation.errors.adminLevel1
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const adminLevel0Id = validation?.values?.adminLevel0?.value;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {
          level: 1,
          adminLevel0: adminLevel0Id,
        };

        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [adminLevel0Id]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="adminLevel1-field" className="form-label">
        Select Administration Level 1
      </Label>
      <Select
        name="adminLevel1"
        id="adminLevel1"
        value={
          validation?.values?.adminLevel1?.value
            ? validation?.values?.adminLevel1
            : null
        }
        placeholder="Select admin level 1"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("adminLevel1", value);
          validation.setFieldError("adminLevel1", "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getRegions({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  name: {
                    $containsi: inputValue,
                  },
                },
              ],
              level: 1,
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.name}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("adminLevel1", true)}
        className={
          validation.touched.adminLevel1 && validation.errors.adminLevel1
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.adminLevel1?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectAdminLevel1;
